<mat-form-field *transloco="let translate" appRemoveAriaOwns>
    <mat-label *transloco="let translate">{{ translate('Select Country') }}</mat-label>
    <mat-select
                [formControl]="control"
                [errorStateMatcher]="matcher"
                [id]="id || 'country'"
                disableOptionCentering>
        <!-- Placeholder option -->
        <mat-option [value]="null">
            <em [textContent]="'--' + translate('Please select') + '--'"></em>
        </mat-option>

        <!-- Search input inside mat-select -->
        <div class="selectSearchFilter">
            <mat-form-field>
                <mat-label *transloco="let translate">{{ translate('Search') }}</mat-label>
                <input
                       matInput
                       [(ngModel)]="country"
                       autocomplete="off"
                       class="inputSearchField" />
                <material-button
                                 matSuffix
                                 *ngIf="country"
                                 buttonType="icon"
                                 size="small"
                                 [titleText]="'Clear'"
                                 prefixIconType="material"
                                 prefixIcon="close"
                                 (buttonClicked)="$event.stopPropagation(); country = ''">
                </material-button>
            </mat-form-field>
        </div>

        <!-- Options filtered by search -->
        <mat-option
                    *ngFor="let option of countries | multiFilter: country"
                    [value]="option.id.toString()">
            <span [textContent]="option.name"></span>
        </mat-option>
    </mat-select>

    <!-- Hint for required field -->
    <mat-hint *ngIf="required && !errors?.length" align="start">
        <strong>
            <span [textContent]="'* ' + translate('required')"></span>
        </strong>
    </mat-hint>

    <!-- Error display -->
    <mat-error *ngIf="control.hasError('errors')" [title]="errors">
        <span [textContent]="errors"></span>
    </mat-error>
</mat-form-field>
